/* eslint-disable react/prop-types */
import React from 'react';
import { Box } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import HomeIcon from './images/home.png';

const iconProps = {
  color: '#BCBCBC',
};

class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isMenuOpen: false };
  }

  handleOnClick() {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  }
  render() {
    return (
      <div>
        <Box position="fixed" top={8} right={15} {...iconProps}>
          <a className="menu-link" href="https://workpath.co.jp/">
            <IconButton color="inherit" onClick={() => this.handleOnClick()}>
              <img src={HomeIcon} width={'50px'} />
            </IconButton>
          </a>
        </Box>
      </div>
    );
  }
}

export default Menu;
